
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqsYeILjJuSfxxexZusu2CItr9y9P4EZQUVNeShFhBpBEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/faq.vue?macro=true";
import { default as club49jSlil1xZCTXqHABG_HAOBAhqafy9NdTccpVNqBEuAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/club.vue?macro=true";
import { default as home9nkJtIMGrjrr4BKTvvj_SFoytI1HEzXm4h9O5fgHkJ0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/home.vue?macro=true";
import { default as about6lqizxETsE7ahaLFdNrLeYfePuEapSn7fXDTwQWiFi0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/about.vue?macro=true";
import { default as indexpu_J88ciwFkNdyTnO4DqCQ_09_SBlozA8E3CQzNW2IoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/index.vue?macro=true";
import { default as termsy_DK2FNJNerAFlwKM8wQTQGKMGszFCQNsqOaU5aMD48Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/terms.vue?macro=true";
import { default as latestaZv2Wx3jt6pRJmA6uh6uCaUKEoEnB_vf4ChB2Ja5iNEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/latest.vue?macro=true";
import { default as searchW7aN0IMF9pnPEkKjn1xMN_awX2CmslM_VDG07PJzD4IMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/search.vue?macro=true";
import { default as _91id_93IsQp0zd79l8tbNZANt2JYaeJaqlicvTvxnClQaIVZUwMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/ppv/[id].vue?macro=true";
import { default as indexP_sa_hMMMsGDk8T_auZeb3jDUatHyoaDS_D3vLd0dGEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/ppv/index.vue?macro=true";
import { default as ppvKWTNtoFExeoiLrhdMUIXi7dpgr_1J_yIP4t7GBepPVcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/ppv.vue?macro=true";
import { default as indexDxYspG5if6ehfR7SdiogyachQgC31uEf6Fz910o797MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/index.vue?macro=true";
import { default as indexKXdUbmVOUkzgsJmDjaLtUb45zkmN4dvcQusoBTJvcVgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/billing/index.vue?macro=true";
import { default as billingO6e6a__HwNDthbf4keVcfidp07yfJPvKbZl2nLjclgkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/billing.vue?macro=true";
import { default as devicespLRDIVNt7QZtlrFnpQMjb_UooxrG9C3IdeBmb1NLcVkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/devices.vue?macro=true";
import { default as generalQDVDm88MOeDCyj4pJDEBKYNlmgwqoMTOqY0L64XpjwEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/general.vue?macro=true";
import { default as password95FUx_0llLOANhpQemvIB5qxMAQF1583dO5atCsu_pIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/password.vue?macro=true";
import { default as _91id_93BAl4cM4dI4PZGOrje5XmzZm3VksaApXbNaW0w29_m7AMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription/[id].vue?macro=true";
import { default as indexHjoubvqkgwwSbvUvUDUggUOYmTz3DlE16_Em36briO8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription/index.vue?macro=true";
import { default as _91id_93735R4V6NzbMAawKzKVMu7b1hkuWvJ4A1b9_cj99lDUQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription/buy/[id].vue?macro=true";
import { default as subscriptionMPuApR0tR7dqkAFW_gdSb91TIPCiGRQHww2kHCCQEDMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription.vue?macro=true";
import { default as accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account.vue?macro=true";
import { default as archiveLqKCVR526CVfMwBK6zOik4xbgCTOC_OcQcEsiJRFqskMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/archive.vue?macro=true";
import { default as privacyGsCr8lmuPW6UNL0muBXuLb_XuG6fdFECs4rdhvbKCCMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/privacy.vue?macro=true";
import { default as open_45apptVz5Zr4a2KnBImZXfrgi7MIfG9cc5KaemSbRUpSDUrMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/open-app.vue?macro=true";
import { default as upcomingAfZS_yCT9OGyLjofGl4vgntKI0kYyiw9Rm3Bjr079h0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/upcoming.vue?macro=true";
import { default as highlightlWF3_nwIYPlujI4rfEyIUrPl_NjcnK0r3_4PR2KegcgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/highlight.vue?macro=true";
import { default as suggestedY_XvdJV9aRBzktVwfXd5GbCVVrW5r62Qo1dk48U5olYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/suggested.vue?macro=true";
import { default as indexF2_0ntpKzimSccNO_90XJNE3m7L_gYyvdd7dx5L1Rv0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/live/index.vue?macro=true";
import { default as dev_45ad_45test8YFQO6aORPOatK_KF3t4mQrMiGhV9hBCsnXDKlFUEnEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/dev-ad-test.vue?macro=true";
import { default as _91type_93WnNPXCVwYDK_pGlZS5KbHJH7TiKT2nf7TtSQMcShzjgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/info/[type].vue?macro=true";
import { default as _91teamId_93ma06teWTpT9mnyp8Bl0lz4k2WWQy4S4tr_AEi8oXCHUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/team/[teamId].vue?macro=true";
import { default as recommendationtzPSwktlNFLSTJiFB3dUU_X_LV_k1UWZTNh_bblAUVAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/recommendation.vue?macro=true";
import { default as clipsTXFTkpMbVF5qEVNoGXpwiN8HYQT5kj746u_WpSruOAMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/selected/clips.vue?macro=true";
import { default as failureegLnrQmolkpCY9w0fjPds0LV1I19j__Z6iuipRJm92IMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/payment/failure.vue?macro=true";
import { default as successL2fL1kulWqagw3pDfkxgtl5ESu2yHBW9oEwNhmYaZgYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/payment/success.vue?macro=true";
import { default as videosTJUVTzhL_LfUYJPcIceMi902jyHS6zO0l4APSlMzB7oMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/selected/videos.vue?macro=true";
import { default as index78omUjjX7QBJi1TkWz9Ai4smDFSA5ukXjKpz50vGvJ8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/login/index.vue?macro=true";
import { default as limithWmeAW4fwzZ8ks7bKX_rUKQBOzaRVgyuUz4X160cXrcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/login/limit.vue?macro=true";
import { default as _91eventId_93FJ9G4hRklai5CjJ5CsQwkUndsYYyxmu7b12fzIWsUZcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/events/[eventId].vue?macro=true";
import { default as indexylB_CIX12h7__IakPCq1XDqeO8WCuh2IQ3vVbPYBZqkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/live/[sportType]/index.vue?macro=true";
import { default as _91sportType_93fK9lKRCZ6lCh_kKgf4uNZblee68D5kBHINWcP9Dw654Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/live/[sportType].vue?macro=true";
import { default as _91leagueId_93oKIv2p9CcuBJUPkEBOAGuVrkOvv0r7EMQ4_hJDE8qtMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/league/[leagueId].vue?macro=true";
import { default as _91id_93Y6zqUHeUuMWBDrosz1uxENj_4WbSMfbMudny63zMTM8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/sub-category/[id].vue?macro=true";
import { default as indexlDmfY0brTxMAb9lR_IOGQg6LgUMt6AaTOmiujBzhfrYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/index.vue?macro=true";
import { default as _91eventId_933gFurgCvNLGWAy6jG17W_FtsyZgE1jpx96B1_pr88OIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/channels/[eventId].vue?macro=true";
import { default as processingThDavxqHeQhjVWA6Y9OAwHApt_rNOjI07QNkyFwEju4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/payment/processing.vue?macro=true";
import { default as resetE9FMLWuokkGaTuXrap3w37iDA3spBpgr4xyIcZ7E6gsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/password/reset.vue?macro=true";
import { default as forgotfzz_D8ysmFBYSB9mQc0eSyYO7KQaOb3g6dm6mbzJxrUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/password/forgot.vue?macro=true";
import { default as _91eventId_93dhmbzdGC_eZjwzuBnxWjhJ_kS1sLuO_b71cUtfitwg4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/events/stats/[eventId].vue?macro=true";
import { default as indexAkxatBRybc_1ytwg_lBqWZrp4Ym5ckjOYEYaZa5Uqr8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/index.vue?macro=true";
import { default as indexDssz_K2QBzSTSZIc70jrjvA8iqvgV_ZyjtZoI31BOAoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/index.vue?macro=true";
import { default as indexVgQ1ohbNsRxuN1B1s9JnYkTtCq0QcEYf4G_h4MR9dtsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/index.vue?macro=true";
import { default as followed_YkwRP3l0v3lJpPybeHgIZAU7iIUvLM7_imh3cd7wDEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/followed.vue?macro=true";
import { default as followed3yxyN5rCAr1NBGyaeaUwYMmrzdyTZQj43uwGwpL1BgcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/followed.vue?macro=true";
import { default as personalizationjPwK5Hd5JkEYYCW9PgVXM2G7hjKC5dv72vLlT_CjIGYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/personalization.vue?macro=true";
import { default as _91referenceId_93vHHScIcdC2Hwjw7L7ylGl_RrrhhV8kPUr47VX76SBmQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/redirect/events/[referenceId].vue?macro=true";
import { default as _91provider_93A_U1B8ESNDhOefInnLPjIBWEYIZbZa2kLAYdiF4MM9cMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/oauth2/callback/[provider].vue?macro=true";
import { default as indexmMjTZt1lHG0GeTGqfk87Wm6AELOpPtP9_FblCsjokNYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/subscription/index.vue?macro=true";
import { default as index6AxA_7Akryj8WOVeqZp40sYBk8lkhOx8jiWI3NTWrsIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/index.vue?macro=true";
import { default as indexz1qtgU49Y2lcmSKWWB_BgtdTikplLh_wUY2uJoIWwrMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/index.vue?macro=true";
import { default as _91id_936_AkahnN5cxDlulrMCOW4QIjJW_wTc8ih8PaySVAapQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/subscription/buy/[id].vue?macro=true";
import { default as index_RZY0qlyOsJdwz_mMxQrH9Yo1OPs_uJBH_DMZwN7Lu4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/league/index.vue?macro=true";
import { default as indexC9Mws_NeQrc336Ugo63UTiDKFQ8X0CR5aTOa4JOFWmIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/subscription/code/index.vue?macro=true";
import { default as followedqAjLawi6wW3H7soE8ej_YG2FQWC4fdnFie7Qd_5rL2MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/followed.vue?macro=true";
import { default as followedHy0clJvliIuttkkVI2ZzNSAD_gSVjbpKqrJV0DDyuSIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/followed.vue?macro=true";
import { default as indexR9lxlxLU8y8PYA8f9odJKE2zcESw1iGy50rithmPaFcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/category/index.vue?macro=true";
import { default as followedl3QYkmSA_KY7KcAdpiI19LDwhjd8EWUas3e67pkjZeMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/league/followed.vue?macro=true";
import { default as _91subId_93xyNpND_bsLs3I56wCx0978mT9O9MG_UmNY_FHWH_c1sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/sub-category/[subId].vue?macro=true";
import { default as followedfwGsiHRkC3VgeKYQ_YTcE_D0pgP3s88SQ9RNU7p57H8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/category/followed.vue?macro=true";
import { default as indexQYgzaYtQbotiuzUn0t8t3Ocz6Cn7maJITnJwTTQfXDAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/category/[mainId]/index.vue?macro=true";
import { default as index0rLgq4vMRLuUMLLWiBUHvcvoN3qLKIrxIzfi_MsbtkQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/league/[leagueId]/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    meta: faqsYeILjJuSfxxexZusu2CItr9y9P4EZQUVNeShFhBpBEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/faq.vue")
  },
  {
    name: "club",
    path: "/club",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/club.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/home.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: about6lqizxETsE7ahaLFdNrLeYfePuEapSn7fXDTwQWiFi0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexpu_J88ciwFkNdyTnO4DqCQ_09_SBlozA8E3CQzNW2IoMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsy_DK2FNJNerAFlwKM8wQTQGKMGszFCQNsqOaU5aMD48Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/terms.vue")
  },
  {
    name: "latest",
    path: "/latest",
    meta: latestaZv2Wx3jt6pRJmA6uh6uCaUKEoEnB_vf4ChB2Ja5iNEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/latest.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchW7aN0IMF9pnPEkKjn1xMN_awX2CmslM_VDG07PJzD4IMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/search.vue")
  },
  {
    name: accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta?.name,
    path: "/account",
    meta: { ...(accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account.vue"),
    children: [
  {
    name: ppvKWTNtoFExeoiLrhdMUIXi7dpgr_1J_yIP4t7GBepPVcMeta?.name,
    path: "ppv",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/ppv.vue"),
    children: [
  {
    name: "account-ppv-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/ppv/[id].vue")
  },
  {
    name: "account-ppv",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/ppv/index.vue")
  }
]
  },
  {
    name: "account",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/index.vue")
  },
  {
    name: billingO6e6a__HwNDthbf4keVcfidp07yfJPvKbZl2nLjclgkMeta?.name,
    path: "billing",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/billing.vue"),
    children: [
  {
    name: "account-billing",
    path: "",
    meta: { ...(indexKXdUbmVOUkzgsJmDjaLtUb45zkmN4dvcQusoBTJvcVgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/billing/index.vue")
  }
]
  },
  {
    name: "account-devices",
    path: "devices",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/devices.vue")
  },
  {
    name: "account-general",
    path: "general",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/general.vue")
  },
  {
    name: "account-password",
    path: "password",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/password.vue")
  },
  {
    name: subscriptionMPuApR0tR7dqkAFW_gdSb91TIPCiGRQHww2kHCCQEDMMeta?.name,
    path: "subscription",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription.vue"),
    children: [
  {
    name: "account-subscription-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription/[id].vue")
  },
  {
    name: "account-subscription",
    path: "",
    meta: { ...(indexHjoubvqkgwwSbvUvUDUggUOYmTz3DlE16_Em36briO8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription/index.vue")
  },
  {
    name: "account-subscription-buy-id",
    path: "buy/:id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/account/subscription/buy/[id].vue")
  }
]
  }
]
  },
  {
    name: "archive",
    path: "/archive",
    meta: archiveLqKCVR526CVfMwBK6zOik4xbgCTOC_OcQcEsiJRFqskMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/archive.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyGsCr8lmuPW6UNL0muBXuLb_XuG6fdFECs4rdhvbKCCMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/privacy.vue")
  },
  {
    name: "open-app",
    path: "/open-app",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/open-app.vue")
  },
  {
    name: "upcoming",
    path: "/upcoming",
    meta: upcomingAfZS_yCT9OGyLjofGl4vgntKI0kYyiw9Rm3Bjr079h0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/upcoming.vue")
  },
  {
    name: "highlight",
    path: "/highlight",
    meta: highlightlWF3_nwIYPlujI4rfEyIUrPl_NjcnK0r3_4PR2KegcgMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/highlight.vue")
  },
  {
    name: "suggested",
    path: "/suggested",
    meta: suggestedY_XvdJV9aRBzktVwfXd5GbCVVrW5r62Qo1dk48U5olYMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/suggested.vue")
  },
  {
    name: "live",
    path: "/live",
    meta: indexF2_0ntpKzimSccNO_90XJNE3m7L_gYyvdd7dx5L1Rv0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/live/index.vue")
  },
  {
    name: "dev-ad-test",
    path: "/dev-ad-test",
    meta: dev_45ad_45test8YFQO6aORPOatK_KF3t4mQrMiGhV9hBCsnXDKlFUEnEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/dev-ad-test.vue")
  },
  {
    name: "info-type",
    path: "/info/:type()",
    meta: _91type_93WnNPXCVwYDK_pGlZS5KbHJH7TiKT2nf7TtSQMcShzjgMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/info/[type].vue")
  },
  {
    name: "team-teamId",
    path: "/team/:teamId()",
    meta: _91teamId_93ma06teWTpT9mnyp8Bl0lz4k2WWQy4S4tr_AEi8oXCHUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/team/[teamId].vue")
  },
  {
    name: "recommendation",
    path: "/recommendation",
    meta: { ...(recommendationtzPSwktlNFLSTJiFB3dUU_X_LV_k1UWZTNh_bblAUVAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/recommendation.vue")
  },
  {
    name: "selected-clips",
    path: "/selected/clips",
    meta: { ...(clipsTXFTkpMbVF5qEVNoGXpwiN8HYQT5kj746u_WpSruOAMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/selected/clips.vue")
  },
  {
    name: "payment-failure",
    path: "/payment/failure",
    meta: { ...(failureegLnrQmolkpCY9w0fjPds0LV1I19j__Z6iuipRJm92IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/payment/failure.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    meta: { ...(successL2fL1kulWqagw3pDfkxgtl5ESu2yHBW9oEwNhmYaZgYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/payment/success.vue")
  },
  {
    name: "selected-videos",
    path: "/selected/videos",
    meta: { ...(videosTJUVTzhL_LfUYJPcIceMi902jyHS6zO0l4APSlMzB7oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/selected/videos.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: index78omUjjX7QBJi1TkWz9Ai4smDFSA5ukXjKpz50vGvJ8Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/login/index.vue")
  },
  {
    name: "auth-login-limit",
    path: "/auth/login/limit",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/login/limit.vue")
  },
  {
    name: "events-eventId",
    path: "/events/:eventId()",
    meta: _91eventId_93FJ9G4hRklai5CjJ5CsQwkUndsYYyxmu7b12fzIWsUZcMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/events/[eventId].vue")
  },
  {
    name: _91sportType_93fK9lKRCZ6lCh_kKgf4uNZblee68D5kBHINWcP9Dw654Meta?.name,
    path: "/live/:sportType()",
    meta: _91sportType_93fK9lKRCZ6lCh_kKgf4uNZblee68D5kBHINWcP9Dw654Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/live/[sportType].vue"),
    children: [
  {
    name: "live-sportType",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/live/[sportType]/index.vue")
  }
]
  },
  {
    name: "league-leagueId",
    path: "/league/:leagueId()",
    meta: _91leagueId_93oKIv2p9CcuBJUPkEBOAGuVrkOvv0r7EMQ4_hJDE8qtMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/league/[leagueId].vue")
  },
  {
    name: "sub-category-id",
    path: "/sub-category/:id()",
    meta: _91id_93Y6zqUHeUuMWBDrosz1uxENj_4WbSMfbMudny63zMTM8Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/sub-category/[id].vue")
  },
  {
    name: "auth-sign-up",
    path: "/auth/sign-up",
    meta: indexlDmfY0brTxMAb9lR_IOGQg6LgUMt6AaTOmiujBzhfrYMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/index.vue")
  },
  {
    name: "channels-eventId",
    path: "/channels/:eventId()",
    meta: _91eventId_933gFurgCvNLGWAy6jG17W_FtsyZgE1jpx96B1_pr88OIMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/channels/[eventId].vue")
  },
  {
    name: "payment-processing",
    path: "/payment/processing",
    meta: { ...(processingThDavxqHeQhjVWA6Y9OAwHApt_rNOjI07QNkyFwEju4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/payment/processing.vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/password/reset.vue")
  },
  {
    name: "auth-password-forgot",
    path: "/auth/password/forgot",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/password/forgot.vue")
  },
  {
    name: "events-stats-eventId",
    path: "/events/stats/:eventId()",
    meta: _91eventId_93dhmbzdGC_eZjwzuBnxWjhJ_kS1sLuO_b71cUtfitwg4Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/events/stats/[eventId].vue")
  },
  {
    name: "following-league",
    path: "/following/league",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/index.vue")
  },
  {
    name: "category-mainId",
    path: "/category/:mainId()",
    meta: indexDssz_K2QBzSTSZIc70jrjvA8iqvgV_ZyjtZoI31BOAoMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/index.vue")
  },
  {
    name: "following-category",
    path: "/following/category",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/index.vue")
  },
  {
    name: "following-league-followed",
    path: "/following/league/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/followed.vue")
  },
  {
    name: "following-category-followed",
    path: "/following/category/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/followed.vue")
  },
  {
    name: "auth-sign-up-personalization",
    path: "/auth/sign-up/personalization",
    meta: { ...(personalizationjPwK5Hd5JkEYYCW9PgVXM2G7hjKC5dv72vLlT_CjIGYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/personalization.vue")
  },
  {
    name: "redirect-events-referenceId",
    path: "/redirect/events/:referenceId()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/redirect/events/[referenceId].vue")
  },
  {
    name: "auth-oauth2-callback-provider",
    path: "/auth/oauth2/callback/:provider()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/oauth2/callback/[provider].vue")
  },
  {
    name: "auth-sign-up-subscription",
    path: "/auth/sign-up/subscription",
    meta: { ...(indexmMjTZt1lHG0GeTGqfk87Wm6AELOpPtP9_FblCsjokNYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/subscription/index.vue")
  },
  {
    name: "following-category-mainId",
    path: "/following/category/:mainId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/index.vue")
  },
  {
    name: "following-league-leagueId",
    path: "/following/league/:leagueId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/index.vue")
  },
  {
    name: "auth-sign-up-subscription-buy-id",
    path: "/auth/sign-up/subscription/buy/:id()",
    meta: _91id_936_AkahnN5cxDlulrMCOW4QIjJW_wTc8ih8PaySVAapQMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/subscription/buy/[id].vue")
  },
  {
    name: "auth-sign-up-following-league",
    path: "/auth/sign-up/following/league",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/league/index.vue")
  },
  {
    name: "auth-sign-up-subscription-code",
    path: "/auth/sign-up/subscription/code",
    meta: { ...(indexC9Mws_NeQrc336Ugo63UTiDKFQ8X0CR5aTOa4JOFWmIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/subscription/code/index.vue")
  },
  {
    name: "following-category-mainId-followed",
    path: "/following/category/:mainId()/followed",
    meta: { ...(followedqAjLawi6wW3H7soE8ej_YG2FQWC4fdnFie7Qd_5rL2MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/followed.vue")
  },
  {
    name: "following-league-leagueId-followed",
    path: "/following/league/:leagueId()/followed",
    meta: { ...(followedHy0clJvliIuttkkVI2ZzNSAD_gSVjbpKqrJV0DDyuSIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/followed.vue")
  },
  {
    name: "auth-sign-up-following-category",
    path: "/auth/sign-up/following/category",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/category/index.vue")
  },
  {
    name: "auth-sign-up-following-league-followed",
    path: "/auth/sign-up/following/league/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/league/followed.vue")
  },
  {
    name: "category-mainId-sub-category-subId",
    path: "/category/:mainId()/sub-category/:subId()",
    meta: _91subId_93xyNpND_bsLs3I56wCx0978mT9O9MG_UmNY_FHWH_c1sMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/sub-category/[subId].vue")
  },
  {
    name: "auth-sign-up-following-category-followed",
    path: "/auth/sign-up/following/category/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/category/followed.vue")
  },
  {
    name: "auth-sign-up-following-category-mainId",
    path: "/auth/sign-up/following/category/:mainId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/category/[mainId]/index.vue")
  },
  {
    name: "auth-sign-up-following-league-leagueId",
    path: "/auth/sign-up/following/league/:leagueId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/base/app/pages/auth/sign-up/following/league/[leagueId]/index.vue")
  }
]